export const money = (amount, withTrailingZeros = false, currency = 'USD') => {
	let money = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency,
		minimumFractionDigits: withTrailingZeros ? 2 : 0,
		maximumFractionDigits: withTrailingZeros ? 2 : 0,
	})

	return money.format(Number(amount / 100))
}
